<template>
    <section id="cta" class="p-0 anchorFix brand-model-selection-bar py-3">
        <f-container>
            <f-row class="justify-content-center">
                <f-col cols="12" sm="12" md="12" lg="3" xl="3" class="text-lg-center mb-3 mb-lg-0">
                    <div class="cta-text float-right d-none d-lg-block">
            SOFORT ZUM<br>
            NEUEN AUTO:
          </div>
          <div class="cta-text text-md-center d-block d-lg-none">
            SOFORT ZUM NEUEN AUTO:
          </div>
        </f-col>
        <f-col cols="12" sm="12" md="5" lg="3" xl="3" class="offset-md-1 offset-lg-0 text-lg-center mb-0">
          <div class="form-group">
            <select class="form-control" id="brandSelect" v-model="selectedBrand" v-on:change="loadVehicles()">
              <option value="">Marke</option>
              <option v-for="brand in brands" :key="brand.id" v-bind:value="brand">
                {{ brand.title }}
              </option>
            </select>
          </div>
        </f-col>
        <f-col cols="12" sm="12" md="5" lg="3" xl="3" class="text-center px-lg-3 text-center">
          <div class="form-group">
            <select class="form-control" id="modelSelect" v-model="selectedModel" :disabled="Object.keys(selectedBrand).length === 0">
              <option value="">Modell</option>
              <option v-for="model in models" :key="model.id" v-bind:value="model">
                {{ model.title }}
              </option>
            </select>
          </div>
        </f-col>
        <f-col cols="12" sm="12" md="4" lg="3" xl="3" class="text-center">
          <f-button variant="primary" :to="getUrl" class="brand-model-cta-button px-5 mobile-block mb-md-2" block>
            Auto finden
          </f-button>

          <a :href="catalogUrl" class="catalog-link d-block d-lg-inline mt-2">
            oder alle Fahrzeuge anzeigen
          </a>
        </f-col>
      </f-row>
    </f-container>
  </section>
</template>

<script>
import {
    FContainer,
    FRow,
    FCol,
    FSelect,
    FSelectOption
} from "faaren-ui";

export default {
    components: {
        FContainer,
        FRow,
        FCol,
        FSelect,
        FSelectOption
    },
    props: {
        catalogUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            brands: Array,
            models: Array,
            selectedBrand: '',
            selectedModel: '',
            catalogSearchUrl: ''
        }
    },
    methods: {
        loadBrands() {
            this.catalogSearchUrl = ''
            axios.get("/api/brand-model-selection/get-active")
                .then(result => {
                    this.brands = result.data
                })
                .catch(error => {
                    console.warn(error.message)
                });
        },
        loadVehicles() {
            axios.get("/api/brands/" + this.selectedBrand.id + '/models')
                .then(result => {
                    this.catalogSearchUrl = this.catalogUrl + '?brand=' + this.selectedBrand.id
                    this.models = result.data
                    this.selectedModel = '';
                })
                .catch(error => {
                    console.warn(error.message)
                });
        }
    },
    watch: {
        selectedBrand: function(val) {
            this.loadVehicles()
        },
    },
    computed: {
        getUrl() {
            if (this.selectedBrand !== '' && this.selectedModel === '') {
                return this.catalogUrl + `?refinementList[brand][0]=${this.selectedBrand.title}`
            }
            if (this.selectedBrand !== '' && this.selectedModel !== '') {
                return this.catalogUrl + `?refinementList[brand][0]=${this.selectedBrand.title}&refinementList[model][0]=${this.selectedModel.title}`
            }
            return this.catalogUrl;
        }
    },
    created() {
        this.loadBrands()
    }
}
</script>

<style scoped>
select {
    height: 47px;
}

.brand-model-selection-bar {
    background: #000;
}

.anchorFix {
    border-top: 95px solid transparent;
    margin: -95px 0 0;
    -webkit-background-clip: padding-box;
    -moz-background-clip: padding;
    background-clip: padding-box;
}

.brand-model-cta-button {
    height: 47px;
    padding-top: 12px;
}

#modelSelect,
#brandSelect {
    border-radius: 3px;
}

.cta-text {
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.catalog-link {
    font-size: 14px;
    text-align: center;
    color: #fff;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .mobile-block {
        width: 100%;
        display: block;
    }
}

@media (min-width: 768px) {
    .cta-text {
        font-size: 16px;
    }
}

@media (min-width: 992px) {
    .cta-text {
        width: 132px;
        text-align: left;
        font-weight: bold;
    }
}
</style>
